import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Switch,
  Typography,
  Tabs,
  Tab,
  Grid,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
// Icons
import DiscountIcon from "@mui/icons-material/Discount";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SelectUpload from "../../Modals/select_upload";
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import CategoryIcon from '@mui/icons-material/Category';
const discountTypes = ["Percentage", "Fixed"];

const AddCampaign = () => {
  const navigate = useNavigate();

  // 🔹 Common states
  const [campaignName, setCampaignName] = useState("");
  const [campaignType, setCampaignType] = useState("");

  // 🔹 Discount Code states
  const [applyOn, setApplyOn] = useState("");
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [discountType, setDiscountType] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [minPurchase, setMinPurchase] = useState("");
  const [usageLimit, setUsageLimit] = useState("");

  // 🔹 Flash Sale states
  const [flashApplyOn, setFlashApplyOn] = useState("");
  const [flashProducts, setFlashProducts] = useState<string[]>([]);

  // 🔹 Common date fields
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  // Example Data
  const categories = ["Clothing", "Electronics", "Home", "Beauty", "Toys"];
  const products = ["T-Shirt", "Laptop", "Sofa", "Lipstick", "Drone"];
  const [bundleType, setBundleType] = useState("");
  const [buyQty, setBuyQty] = useState("");
  const [getQty, setGetQty] = useState("");
  const [eligibleProducts, setEligibleProducts] = useState<string[]>([]);
  const [freeSameProduct, setFreeSameProduct] = useState(true);

  const [bundleProducts, setBundleProducts] = useState<string[]>([]);
  const [bundlePrice, setBundlePrice] = useState("");
  const [originalTotal, setOriginalTotal] = useState("");
  const locations = ["USA", "Canada", "UK", "Australia", "India"];

  const [qtyDiscountType, setQtyDiscountType] = useState("");
  const [qtyDiscountValue, setQtyDiscountValue] = useState("");
  const [minQty, setMinQty] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleSave = () => {
    const payload = {
      campaignName,
      campaignType,
      applyOn,
      selectedItems,
      discountType,
      discountValue,
      minPurchase,
      usageLimit,
      flashApplyOn,
      flashProducts,
      bundleType,
      buyQty,
      getQty,
      eligibleProducts,
      freeSameProduct,
      bundleProducts,
      bundlePrice,
      originalTotal,
      qtyDiscountType,
      qtyDiscountValue,
      minQty,
      startDate,
      endDate,
    };

    console.log("Campaign Data:", payload);
  };
  const [premiumToolType, setPremiumToolType] = useState("");
  const premiumToolOptions = [
    "Homepage Banner",
    "Homepage Slider",
    "Category Banner",
    "Featured Product Tag",
  ];

  // Campaign Type Cards
  const campaignTypeOptions = [
    {
      value: "Discount Code",
      icon: <DiscountIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Discount Code",
      subtitle: "Percentage or fixed amount off",
    },
    {
      value: "Flash Sale",
      icon: <ElectricBoltIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Flash Sale",
      subtitle: "Limited time special offers",
    },
    {
      value: "Bundle Deal",
      icon: <LocalMallIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Bundle Deal",
      subtitle: "Buy multiple, save more",
    },
    {
      value: "Free Shipping",
      icon: <LocalShippingIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Free Shipping",
      subtitle: "No shipping charges",
    },
    {
      value: "Homepage Banner",
      icon: <ViewCarouselIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Homepage Banner",
      subtitle: "Banner section",
      tag:"Premium"
    },
    {
      value: "Homepage Slider",
      icon: <ViewCarouselIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Homepage Slider",
      subtitle: "Slider section",
      tag:"Premium"
    },
    {
      value: "Category Banner",
      icon: <CategoryIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Category Banner",
      subtitle: "Category Section",
      tag:"Premium"
    },
    {
      value: "Featured Product Tag",
      icon: <ProductionQuantityLimitsIcon sx={{ fontSize: 32, color: "#c69a38" }} />,
      title: "Featured Product Tag",
      subtitle: "Featured products section",
      tag:"Premium"
    },
  ];
  // Handle auto-calc for original total (example only)
  const calculateOriginalTotal = (selected: string[]) => {
    // Pretend each product is $10 for this demo
    const total = selected.length * 10;
    setOriginalTotal(total.toString());
  };
  const [subTab, setSubTab] = useState(0);

  const handleSubTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setSubTab(newValue);
  };
  const subTabs: ("Free Tool" | "Premium Tool")[] = [
    "Free Tool",
    "Premium Tool",
  ];

  return (
    <>
      <div className="main_title">
        <h1>Add Campaign</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/marketing")}>
            Marketing Suite
          </button>{" "}
          - Create Campaign
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_m w_100">
            {/* Campaign Name */}
            <div className="control_group w_50">
              <label>Campaign Name</label>
              <TextField
                placeholder="Enter Campaign Name"
                fullWidth
                value={campaignName}
                onChange={(e) => setCampaignName(e.target.value)}
              />
            </div>

            {/* Campaign Type */}
            <div className="control_group w_100">
              <label>Campaign Type</label>
              <div className="campaign_type_grid">
                {campaignTypeOptions.map((type) => (
                  <Box
                    key={type.value}
                    className={`campaign_type_card ${
                      campaignType === type.value ? "selected" : ""
                    }`}
                    onClick={() => setCampaignType(type.value)}
                  >
                    <div className="icon_wrap">{type.icon}</div>
                    <h4>{type.title}</h4>
                    <p>{type.subtitle}</p>
                    {type.tag &&(
                      <span> {type.tag}</span>
                    )
                    }
                  </Box>
                ))}
              </div>
            </div>

            {/* 🟦 DISCOUNT CODE FIELDS */}
            {campaignType === "Discount Code" && (
              <>
                <div className="control_group w_50">
                  <label>Apply Discount On</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={applyOn}
                      onChange={(e) => {
                        setApplyOn(e.target.value);
                        setSelectedItems([]);
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select where discount applies
                      </MenuItem>
                      <MenuItem value="Category">Category</MenuItem>
                      <MenuItem value="Product">Product</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                {applyOn && (
                  <div className="control_group w_100">
                    <label>Select {applyOn}</label>
                    <FormControl fullWidth>
                      <Select
                        multiple
                        displayEmpty
                        value={selectedItems}
                        onChange={(e) =>
                          setSelectedItems(e.target.value as string[])
                        }
                        input={<OutlinedInput />}
                        renderValue={(selected) =>
                          selected.length === 0
                            ? `Select ${applyOn}(s)`
                            : selected.join(", ")
                        }
                      >
                        {(applyOn === "Category" ? categories : products).map(
                          (name) => (
                            <MenuItem key={name} value={name}>
                              <Checkbox
                                checked={selectedItems.indexOf(name) > -1}
                              />
                              <ListItemText primary={name} />
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </div>
                )}

                <div className="control_group w_50">
                  <label>Discount Type</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={discountType}
                      onChange={(e) => setDiscountType(e.target.value)}
                    >
                      <MenuItem value="" disabled>
                        Select Discount Type
                      </MenuItem>
                      {discountTypes.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className="control_group w_50">
                  <label>Discount Value</label>
                  <TextField
                    placeholder="Enter Discount Value"
                    fullWidth
                    type="number"
                    value={discountValue}
                    onChange={(e) => setDiscountValue(e.target.value)}
                  />
                </div>

                <div className="control_group w_50">
                  <label>Minimum Purchase Amount (Optional)</label>
                  <TextField
                    placeholder="Enter Minimum Purchase Amount"
                    fullWidth
                    type="number"
                    value={minPurchase}
                    onChange={(e) => setMinPurchase(e.target.value)}
                  />
                </div>

                <div className="control_group w_50">
                  <label>Usage Limit (Optional)</label>
                  <TextField
                    placeholder="Enter Usage Limit"
                    fullWidth
                    type="number"
                    value={usageLimit}
                    onChange={(e) => setUsageLimit(e.target.value)}
                  />
                </div>
              </>
            )}

            {/* ⚡ FLASH SALE FIELDS */}
            {campaignType === "Flash Sale" && (
              <>
                {/* Dropdown: Category / All Products / Specific Products */}
                <div className="control_group w_50">
                  <label>Apply Flash Sale On</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={flashApplyOn}
                      onChange={(e) => {
                        setFlashApplyOn(e.target.value);
                        setFlashProducts([]);
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select where flash sale applies
                      </MenuItem>
                      <MenuItem value="Category">Category</MenuItem>
                      <MenuItem value="All Products">All Products</MenuItem>
                      <MenuItem value="Specific Products">
                        Specific Products
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>

                {/* Multiselect only when Specific Products selected */}
                {flashApplyOn === "Specific Products" && (
                  <div className="control_group w_100">
                    <label>Select Products</label>
                    <FormControl fullWidth>
                      <Select
                        multiple
                        displayEmpty
                        value={flashProducts}
                        onChange={(e) =>
                          setFlashProducts(e.target.value as string[])
                        }
                        input={<OutlinedInput />}
                        renderValue={(selected) =>
                          selected.length === 0
                            ? "Select Product(s)"
                            : selected.join(", ")
                        }
                      >
                        {products.map((name) => (
                          <MenuItem key={name} value={name}>
                            <Checkbox
                              checked={flashProducts.indexOf(name) > -1}
                            />
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}
              </>
            )}
            {campaignType === "Bundle Deal" && (
              <>
                <div className="control_group w_50">
                  <label>Bundle Type</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={bundleType}
                      onChange={(e) => setBundleType(e.target.value)}
                    >
                      <MenuItem value="" disabled>
                        Select Bundle Type
                      </MenuItem>
                      <MenuItem value="Buy X Get Y">Buy X Get Y Free</MenuItem>
                      <MenuItem value="Combo Offer">Combo Offer</MenuItem>
                      <MenuItem value="Quantity Discount">
                        Quantity-based Discount
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>

                {/* 1️⃣ Buy X Get Y Free */}
                {bundleType === "Buy X Get Y" && (
                  <>
                    <div className="control_group w_50">
                      <label>Buy Quantity</label>
                      <TextField
                        placeholder="Enter Buy Quantity (e.g. 2)"
                        fullWidth
                        type="number"
                        value={buyQty}
                        onChange={(e) => setBuyQty(e.target.value)}
                      />
                    </div>

                    <div className="control_group w_50">
                      <label>Get Quantity</label>
                      <TextField
                        placeholder="Enter Free Quantity (e.g. 1)"
                        fullWidth
                        type="number"
                        value={getQty}
                        onChange={(e) => setGetQty(e.target.value)}
                      />
                    </div>

                    <div className="control_group w_100">
                      <label>Eligible Products</label>
                      <FormControl fullWidth>
                        <Select
                          multiple
                          displayEmpty
                          value={eligibleProducts}
                          onChange={(e) =>
                            setEligibleProducts(e.target.value as string[])
                          }
                          input={<OutlinedInput />}
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "Select Product(s)"
                              : selected.join(", ")
                          }
                        >
                          {products.map((name) => (
                            <MenuItem key={name} value={name}>
                              <Checkbox
                                checked={eligibleProducts.indexOf(name) > -1}
                              />
                              <ListItemText primary={name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <Box display="flex" alignItems="center" gap={1}>
                      <Typography>Free Product Same as Purchased?</Typography>
                      <Switch
                        checked={freeSameProduct}
                        onChange={() => setFreeSameProduct(!freeSameProduct)}
                      />
                    </Box>
                  </>
                )}

                {/* 2️⃣ Combo Offer */}
                {bundleType === "Combo Offer" && (
                  <>
                    <div className="control_group w_100">
                      <label>Select Products for Bundle</label>
                      <FormControl fullWidth>
                        <Select
                          multiple
                          displayEmpty
                          value={bundleProducts}
                          onChange={(e) => {
                            const value = e.target.value as string[];
                            setBundleProducts(value);
                            calculateOriginalTotal(value);
                          }}
                          input={<OutlinedInput />}
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "Select Product(s)"
                              : selected.join(", ")
                          }
                        >
                          {products.map((name) => (
                            <MenuItem key={name} value={name}>
                              <Checkbox
                                checked={bundleProducts.indexOf(name) > -1}
                              />
                              <ListItemText primary={name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="control_group w_50">
                      <label>Bundle Price</label>
                      <TextField
                        placeholder="Enter Bundle Price"
                        fullWidth
                        type="number"
                        value={bundlePrice}
                        onChange={(e) => setBundlePrice(e.target.value)}
                      />
                    </div>

                    <div className="control_group w_50">
                      <label>Original Total (Auto Calculated)</label>
                      <TextField
                        fullWidth
                        value={originalTotal}
                        disabled
                        placeholder="Auto-calculated total"
                      />
                    </div>
                  </>
                )}

                {/* 3️⃣ Quantity-based Discount */}
                {bundleType === "Quantity Discount" && (
                  <>
                    <div className="control_group w_50">
                      <label>Minimum Quantity</label>
                      <TextField
                        placeholder="Enter Minimum Quantity"
                        fullWidth
                        type="number"
                        value={minQty}
                        onChange={(e) => setMinQty(e.target.value)}
                      />
                    </div>

                    <div className="control_group w_50">
                      <label>Discount Type</label>
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          value={qtyDiscountType}
                          onChange={(e) => setQtyDiscountType(e.target.value)}
                        >
                          <MenuItem value="" disabled>
                            Select Discount Type
                          </MenuItem>
                          {discountTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                              {type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="control_group w_50">
                      <label>Discount Value</label>
                      <TextField
                        placeholder="Enter Discount Value"
                        fullWidth
                        type="number"
                        value={qtyDiscountValue}
                        onChange={(e) => setQtyDiscountValue(e.target.value)}
                      />
                    </div>
                  </>
                )}
              </>
            )}
            {/* 🚚 FREE SHIPPING FIELDS */}
            {campaignType === "Free Shipping" && (
              <>
                <div className="control_group w_50">
                  <label>Apply Free Shipping On</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={applyOn}
                      onChange={(e) => {
                        setApplyOn(e.target.value);
                        setSelectedItems([]);
                      }}
                    >
                      <MenuItem value="" disabled>
                        Select where free shipping applies
                      </MenuItem>
                      <MenuItem value="Product">Product</MenuItem>
                      <MenuItem value="Location">Location</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                {/* Multiselect based on choice */}
                {applyOn && (
                  <div className="control_group w_100">
                    <label>Select {applyOn}(s)</label>
                    <FormControl fullWidth>
                      <Select
                        multiple
                        displayEmpty
                        value={selectedItems}
                        onChange={(e) =>
                          setSelectedItems(e.target.value as string[])
                        }
                        input={<OutlinedInput />}
                        renderValue={(selected) =>
                          selected.length === 0
                            ? `Select ${applyOn}(s)`
                            : selected.join(", ")
                        }
                      >
                        {(applyOn === "Product" ? products : locations).map(
                          (name) => (
                            <MenuItem key={name} value={name}>
                              <Checkbox
                                checked={selectedItems.indexOf(name) > -1}
                              />
                              <ListItemText primary={name} />
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </FormControl>
                  </div>
                )}
              </>
            )}
            {(campaignType === "Homepage Banner" ||
              campaignType === "Homepage Slider" ||
              campaignType === "Category Banner") && (
              <>
                <div className="control_group wrap_viewDemo_steps">
                  <label>
                    Upload Banner{" "}
                    <img
                      className="cr_pt"
                      src="/static/images/ai_icon.svg"
                      alt=""
                    />{" "}
                  </label>
                  <div className="upload_box">
                    <label
                      className="upload_action"
                      onClick={() => setOpenModal(true)}
                      style={{ minHeight: "195px" }}
                    >
                      <p>
                        <img src="/static/images/upload_icon.svg" alt="icon" />
                        <strong>Click to upload image or take photo</strong>
                      </p>
                    </label>
                  </div>
                </div>
                <div className="control_group w_50">
                  <label htmlFor="">Amount</label>
                  <TextField disabled placeholder="AED 5000" fullWidth />
                </div>
                <div
                  className="control_group w_100"
                  style={{ marginTop: "15px" }}
                >
                  <div className="checkbox_item">
                    <label>
                      <input type="checkbox" /> I confirm the uploaded creatives
                      meet the guidelines.
                    </label>
                  </div>

                  <div className="checkbox_item">
                    <label>
                      <input type="checkbox" /> I understand this booking is
                      non-refundable.
                    </label>
                  </div>

                  <div className="checkbox_item">
                    <label>
                      <input type="checkbox" /> I agree to the Marketplace
                      Advertising Terms.
                    </label>
                  </div>

                  <div className="checkbox_item">
                    <a
                      href="#"
                      style={{
                        color: "#0077cc",
                        textDecoration: "underline",
                        fontWeight: 500,
                        marginTop: "5px",
                        display: "inline-block",
                      }}
                    >
                      View Guidelines
                    </a>
                  </div>
                </div>
                <div className="cards">
                  <div className="flex_clm">
                    <Typography>
                      One-time fee AED 300. Featured for 7 days from the moment
                      this campaign goes live after approval.
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ marginLeft: "4px" }}
                    >
                      Estimated period: 12 Dec 2025 – 19 Dec 2025
                      <br />
                    </Typography>
                  </div>
                </div>
                <div className="control_group w_100">
                  <Button className="btn btn_primary">
                    Proceed For Payment
                  </Button>
                </div>
              </>
            )}
            {/* SHOW PRODUCT DROPDOWN IF FEATURED PRODUCT TAG */}
            {campaignType === "Featured Product Tag" && (
              <>
                <div className="control_group w_50">
                  <label>Select Product For Tag</label>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      value={selectedItems}
                      onChange={(e) =>
                        setSelectedItems([e.target.value as string])
                      }
                    >
                      <MenuItem value="" disabled>
                        Select a Product
                      </MenuItem>

                      {products.map((product) => (
                        <MenuItem key={product} value={product}>
                          {product}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="control_group w_50">
                  <label htmlFor="">Amount</label>
                  <TextField disabled placeholder="AED 5000" fullWidth />
                </div>
                <div className="cards">
                  <div className="flex_clm">
                    <Typography>
                      One-time fee AED 5000. Featured for 7 days from the moment
                      this campaign goes live after approval.
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ marginLeft: "4px" }}
                    >
                      Estimated period: 12 Dec 2025 – 19 Dec 2025
                      <br />
                    </Typography>
                  </div>
                </div>
                <div className="control_group w_100">
                  <Button className="btn btn_primary">
                    Proceed For Payment
                  </Button>
                </div>
              </>
            )}
          </div>

          <div className="btn_flex mt_20">
            <Button className="btn btn_primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </div>

      <SelectUpload
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default AddCampaign;
